import { boatConstants } from './boat.constants'

const initialState = {
  boats: [],
  logBookEntries: [],
  loadingLogBookEntries: false,
  loadingBoats: false,
  error: null,

  loadingBoatInfoForBoat: false,
  loadingBoatInfoError: null,
  selectedBoat: null,
  loadingSelectedBoat: false,
  aisPosition: {},

  aisPositionsForAvailableBoatsLoading: false,
  aisPositionsForAvailableBoats: [],
  aisPositionsForAvailableBoatsError: null,

  creatingBoats: false,
  boatCreated: false,
  creatingBoatError: null,
  boatForSaving: {
    boatId: 0,
    boatTypeId: 0,
    imo: 0,
    mmsi: 0,
    name: '',
    model: '',
    callsign: '',
    loa: 0,
    loh: 0,
    beam: 0,
    draft: 0,
    displacement: 0,
    yearBuilt: 0,
    builtBy: '',
    buildNo: '',
    certifiedUntil: '',
    regDate: '',
    registeredBy: 0,
  },
  boatTypes: [],

  boatTypeCategories: [],
  loadingBoatTypeCategories: false,

  boatTradingAreas: [],
  loadingBoatTradingAreas: false,

  clientsForUser: [],
  loadingClientsForUser: false,

  accessGroupsForClient: [],
  loadingAccessGroupsForClient: false,

  usersForBoat: [],
  loadingUsersForBoat: false,

  uploadingImageForBoat: true,
  uploadingError: null,

  imageIdsForBoat: [],
  loadingImageIdsForBoat: false,
  imageIdsLoadingError: null,

  updatingBoatStatus: false,
  updatingBoatStatusError: null,

  suppliers: [],
  loadingSuppliers: false,

  loadingHullTypes: false,
  hullTypes: [],

  creatingLogBookEntry: false,
}

export function boats(state = initialState, action) {
  switch (action.type) {
    case boatConstants.CREATE_BOAT_LOGBOOK_ENTRY_LOADING:
      return {
        ...state,
        creatingLogBookEntry: true,
      }

    case boatConstants.CREATE_BOAT_LOGBOOK_ENTRY_ERROR:
      return {
        ...state,
        creatingLogBookEntry: false,
        error: action.error,
      }

    case boatConstants.CREATE_BOAT_LOGBOOK_ENTRY_SUCCESS:
      return {
        ...state,
        creatingLogBookEntry: false,
      }

    case boatConstants.FETCH_BOAT_LOGBOOK_ENTRIES_ERROR:
      return {
        ...state,
        loadingLogBookEntries: false,
        error: action.error,
      }

    case boatConstants.FETCH_BOAT_LOGBOOK_ENTRIES_LOADING:
      return {
        ...state,
        loadingLogBookEntries: true,
      }

    case boatConstants.FETCH_BOAT_LOGBOOK_ENTRIES_SUCCESS:
      return {
        ...state,
        loadingLogBookEntries: false,
        logBookEntries: action.logBookEntries,
      }

    //ALL BOATS
    case boatConstants.FETCH_ALL_AVAILABLE_BOATS_LOADING:
      return {
        ...state,
        loadingBoats: true,
      }
    case boatConstants.FETCH_ALL_AVAILABLE_BOATS_SUCCESS:
      return {
        ...state,
        loadingBoats: false,
        boats: action.boats,
      }
    case boatConstants.FETCH_ALL_AVAILABLE_BOATS_ERROR:
      return {
        ...state,
        loadingBoats: false,
        error: 'Feil under lasting av båter',
      }

    //SINGLE BOAT
    case boatConstants.FETCH_BOAT_INFO_FOR_BOAT_LOADING:
      return {
        ...state,
        loadingSelectedBoat: true,
        selectedBoat: null,
        logBookEntries: [],
        loadingBoatInfoForBoat: true,
      }
    case boatConstants.FETCH_BOAT_INFO_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingBoatInfoForBoat: false,
        loadingBoatInfoError: action.error,
        loadingSelectedBoat: false,
      }
    case boatConstants.FETCH_BOAT_INFO_FOR_BOAT_SUCCESS:
      return {
        ...state,
        loadingBoatInfoForBoat: false,
        selectedBoat: action.boat,
        loadingSelectedBoat: false,
      }
    case boatConstants.FETCH_BOAT_AIS_POSITION_SUCCESS:
      return {
        ...state,
        aisPosition: {
          ...state.aisPosition,
          [action.boatId]: action.aisPosition,
        },
      }
    case boatConstants.FETCH_ALL_AIS_POSITIONS_FOR_BOATS_LOADING:
      return {
        ...state,
        aisPositionsForAvailableBoatsLoading: true,
        aisPositionsForAvailableBoatsError: null,
      }
    case boatConstants.FETCH_ALL_AIS_POSITIONS_FOR_BOATS_SUCCESS:
      return {
        ...state,
        aisPositionsForAvailableBoatsLoading: false,
        aisPositionsForAvailableBoatsError: null,
        aisPositionsForAvailableBoats: action.aisPositions,
      }
    case boatConstants.FETCH_ALL_AIS_POSITIONS_FOR_BOATS_ERROR:
      return {
        ...state,
        aisPositionsForAvailableBoatsLoading: false,
        aisPositionsForAvailableBoatsError: action.error,
      }

    case boatConstants.RESET_SELECTED_BOAT:
      return {
        ...state,
        selectedBoat: null,
        logBookEntries: [],
      }
    case boatConstants.RESET_ERROR:
      return {
        ...state,
        creatingBoatError: null,
      }
    case boatConstants.RESET_BOAT_LIST:
      return {
        ...state,
        selectedBoat: null,
        logBookEntries: [],
        boats: [],
        boatsForClients: [],
        aisPosition: {},
      }
    //CREATE NEW BOAT
    case boatConstants.CREATE_NEW_BOAT:
      return {
        ...state,
        boatCreated: false,
      }
    case boatConstants.UPDATE_BOAT_FOR_SAVING:
      return {
        ...state,
        boatForSaving: {
          ...state.boatForSaving,
          [action.name]: action.value,
        },
      }
    case boatConstants.SAVING_NEW_BOAT:
      return {
        ...state,
        creatingBoats: true,
      }
    case boatConstants.SAVING_NEW_BOAT_SUCCESSFUL:
      return {
        ...state,
        creatingBoats: false,
        boatCreated: true,
      }
    case boatConstants.SAVING_NEW_BOAT_ERROR:
      return {
        ...state,
        creatingBoats: false,
        boatCreated: false,
        creatingBoatError: action.error,
        boatTypes: state.boatTypes,
      }
    case boatConstants.UPDATE_BOAT_ERROR:
      return {
        ...state,
        creatingBoatError: action.error,
      }
    case boatConstants.GET_BOAT_TYPES_SUCCESS:
      return {
        ...state,
        boatTypes: action.boatTypes,
      }
    case boatConstants.GET_BOAT_TYPES_ERROR:
      return {
        ...state,
        error: action.error,
      }

    case boatConstants.GET_BOAT_TYPE_CATEGORIES:
      return {
        ...state,
        loadingBoatTypeCategories: true,
      }
    case boatConstants.GET_BOAT_TYPE_CATEGORIES_SUCCESS:
      return {
        ...state,
        loadingBoatTypeCategories: false,
        boatTypeCategories: action.boatTypeCategories,
      }
    case boatConstants.GET_BOAT_TYPE_CATEGORIES_ERROR:
      return {
        ...state,
        loadingBoatTypeCategories: false,
        error: action.error,
      }

    case boatConstants.GET_CLIENTS_FOR_USER:
      return {
        ...state,
        loadingClientsForUser: true,
      }
    case boatConstants.GET_CLIENTS_FOR_USER_SUCCESS:
      return {
        ...state,
        loadingClientsForUser: false,
        clientsForUser: action.clients,
      }
    case boatConstants.GET_CLIENTS_FOR_USER_ERROR:
      return {
        ...state,
        loadingClientsForUser: false,
        error: action.error,
      }
    case boatConstants.FETCH_ACCESSGROUPS_FOR_CLIENT_LOADING:
      return {
        ...state,
        loadingAccessGroupsForClient: true,
      }
    case boatConstants.FETCH_ACCESSGROUPS_FOR_CLIENT_SUCCESS:
      return {
        ...state,
        loadingAccessGroupsForClient: false,
        accessGroupsForClient: action.accessGroups,
      }
    case boatConstants.FETCH_ACCESSGROUPS_FOR_CLIENT_ERROR:
      return {
        ...state,
        loadingAccessGroupsForClient: false,
      }

    case boatConstants.GET_BOAT_TRADING_AREAS:
      return {
        ...state,
        loadingBoatTradingAreas: true,
      }
    case boatConstants.GET_BOAT_TRADING_AREAS_SUCCESS:
      return {
        ...state,
        loadingBoatTradingAreas: false,
        boatTradingAreas: action.boatTradingAreas,
      }
    case boatConstants.GET_BOAT_TRADING_AREAS_ERROR:
      return {
        ...state,
        loadingBoatTradingAreas: false,
        error: action.error,
      }
    case boatConstants.FETCH_USERS_FOR_BOAT_LOADING:
      return {
        ...state,
        usersForBoat: [],
        loadingUsersForBoat: true,
      }
    case boatConstants.FETCH_USERS_FOR_BOAT_SUCCESS:
      return {
        ...state,
        usersForBoat: action.users,
        loadingUsersForBoat: false,
      }
    case boatConstants.FETCH_USERS_FOR_BOAT_ERROR:
      return {
        ...state,
        loadingUsersForBoat: false,
        error: action.error,
      }

    case boatConstants.GET_HULL_TYPES:
      return {
        ...state,
        loadingHullTypes: true,
      }
    case boatConstants.GET_HULL_TYPES_SUCCESS:
      return {
        ...state,
        loadingHullTypes: false,
        hullTypes: action.hullTypes,
      }
    case boatConstants.GET_HULL_TYPES_ERROR:
      return {
        ...state,
        loadingHullTypes: false,
        error: action.error,
      }
    case boatConstants.UPDATE_BOAT_STATUS_STARTED:
      return {
        ...state,
        updatingBoatStatus: true,
      }
    case boatConstants.UPDATE_BOAT_STATUS_SUCCESSFUL:
      return {
        ...state,
        updatingBoatStatus: false,
      }
    case boatConstants.UPDATE_BOAT_STATUS_ERROR:
      return {
        ...state,
        updatingBoatStatus: false,
        updatingBoatStatusError: 'Error while updating boat status',
      }
    case boatConstants.GET_SUPPLIERS_LOADING:
      return {
        ...state,
        loadingSuppliers: true,
      }
    case boatConstants.GET_SUPPLIERS_SUCCESS:
      return {
        ...state,
        loadingSuppliers: false,
        suppliers: action.suppliers,
      }
    case boatConstants.GET_SUPPLIERS_ERROR:
      return {
        ...state,
        loadingSuppliers: true,
        error: action.error,
      }
    default:
      return state
  }
}
